
import { Tag, Button } from "antd"
import { useEffect, useState } from "react"
import { URL_BACKEND } from "../../api/url"
import { elToast } from "../../functions/alertas"

const useReporteEstadoExamen = () => {

    // variables
    const [loading, setLoading] = useState( true )
    const [data, setData] = useState()
    const [datosReporteEstadoExamen, setDatosReporteEstadoExamen] = useState( [] )
    const [textoBuscar, setTextoBuscar] = useState("")


    // funciones
    const traerDatosReporteEstadoExamen = () => {

        setLoading( true )
        let body = new FormData()
        body.append('funcion', 'traerDatosReporteEstadoExamen')

        fetch( URL_BACKEND, {
            body,
            method: 'post'
        })
        .then( r => r.json() )
        .then( d => {
            setData( d )
            setDatosReporteEstadoExamen( d )
            setLoading( false )
        })
    }


    const filtrar = ( cosaABuscar ) => {

        cosaABuscar = cosaABuscar.trim()

        if (cosaABuscar) {
            // aquí haremos una búsqueda porque el usuario escribió algo
            var resultadosNuevos = data.filter( function( elemento ){

                let busqueda = new RegExp( cosaABuscar, 'gi' )
                if ( busqueda.test( elemento.nombre ) ) {
                    return true
                } else {
                    return false
                }

            })
            setDatosReporteEstadoExamen( resultadosNuevos )

        } else {
            // aquí no haremos la búsqueda, pero devolvemos todos los elementos
            setDatosReporteEstadoExamen( data )
        }
    }


    const reiniciar = ( pk_estado_examen, aspirante, materia ) => {
        let borrar = window.confirm(`Reiniciar el progreso para ${aspirante} en la materia ${materia}`)
        if ( borrar ) {

            let body = new FormData()
            body.append( 'funcion', 'reiniciarProgresoAspirante' )
            body.append( 'pk_estado_examen', pk_estado_examen )

            fetch( URL_BACKEND, {
                method: 'post',
                body
            })
            .then( r => r.json() )
            .then( a => {
                if ( a.codigo === 1 ) {
                    elToast( 'Datos reiniciados con éxito' )
                    document.querySelector('#inputBuscarEstadoExamen').value = ''

                    let dataSource = [...data];
                    let nuevosDatos = dataSource.filter(item => item.pk_estado_examen !== pk_estado_examen)
                    setData( nuevosDatos )
                    // setDatosReporteEstadoExamen( nuevosDatos )
                    let tb = textoBuscar + " "
                    setTextoBuscar( tb )

                } else {
                    elToast( 'Error al reiniciar progreso' )
                }
            })
            .catch( () => alert('Error, inténtelo nuevamente') )
        }
    }

    // useEffects
    useEffect(() => {
        traerDatosReporteEstadoExamen()
    }, [])

    useEffect(() => {

        filtrar( textoBuscar )

    }, [ textoBuscar ])




    // tabla
    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'nombre'
        },
        {
            title: 'Materia',
            dataIndex: 'materia',
        },
        {
            title: 'Fecha de inicio',
            dataIndex: 'fecha_inicio'
        },
        {
            title: 'Fecha final',
            dataIndex: 'fecha_final',
            render: ( t ) => {

                var fecha_final

                if ( t ) {
                    fecha_final = t
                } else {
                    fecha_final = <Tag color="gold"> Pendiente </Tag>
                }

                return fecha_final
            }
        },
        {
            title: 'Duración',
            dataIndex: 'duracion',
            render: ( t ) => {

                var duracion

                if ( t ) {
                    duracion = t
                } else {
                    duracion = <Tag color="gold"> Pendiente </Tag>
                }

                return duracion
            }
        },
        {
            title: 'Estatus',
            dataIndex: 'estado',
            render: ( t ) => {

                var status

                if ( t === '1' ) {
                    status = <Tag color="blue"> Finalizado </Tag>
                } else {
                    status = <Tag color="gold"> Pendiente </Tag>
                }

                return status
            }
        },
        {
            title: 'Opciones',
            render: (t, r) => (
                <Button type="dashed" danger onClick={ () => reiniciar( r.pk_estado_examen, r.nombre, r.materia ) }>Habilitar</Button>
            )
        }
    ];


    return {
        loading,
        columns,
        datosReporteEstadoExamen,
        filtrar,
        textoBuscar,
        setTextoBuscar,
        traerDatosReporteEstadoExamen
    }
}

export default useReporteEstadoExamen
